// Résumé content, taken from Paulin_Niyobyose_CV.
export const TITLE = "Software Engineer";

export const PROFILE =
    "Software Engineer with experience building full-stack web/mobile applications, AI-powered solutions, and scalable software systems. Skilled in modern development, databases, cloud, DevOps, and AI-assisted development, with additional expertise in BIM technologies. Passionate about solving complex problems and building reliable, practical software.";

export const experience = [
    {
        company: "Digital Cost Estimation",
        role: "Backend developer",
        period: "09/2024 – 07/2026",
        points: [
            "Developed platforms for employee management, project budget planning, and construction cost estimation.",
            "Created custom plugins for Revit and Archicad to export and report BIM data.",
            "Built cost estimation tools for generating bills of quantities.",
        ],
    },
    {
        company: "ACORN APPRAISALS",
        role: "Software developer",
        period: "09/2025 – 08/2026",
        location: "Canada",
        points: [
            "Developed a comprehensive Smart Evaluation system for structured reporting, interactive charts, tables, and visual assets.",
            "Built collaboration features and scalable PDF/Word report generation.",
            "Containerized application services with Docker and streamlined development and deployment environments.",
            "Built modern, responsive business applications and integrated backend services.",
        ],
    },
    {
        company: "Is Technologies Lt",
        role: "Front-end developer",
        period: "04/2024 – 01/2025",
        location: "Rubavu, Rwanda",
        points: [
            "Developed a secure, interactive web application using React.js and Tailwind CSS, with a focus on usability and responsive design.",
        ],
    },
    {
        company: "Upwork",
        role: "Freelancer",
        period: "02/2024 – 12/2025",
        location: "Remote",
        points: ["Serves as a top-rated freelancer at upwork, contribution to many projects."],
    },
    {
        company: "Kick side Rwanda",
        role: "Frontend Developer",
        period: "08/2024 – 12/2024",
        points: [
            "Developed modern websites, including the official Kickside newspaper publishing site.",
            "Collaborated with backend teams on software solutions.",
            "Implemented responsive designs and optimized user experience.",
            "Worked with Git and containerized development workflows.",
        ],
    },
];

export const education = [
    {
        program: "Software Programming and Embedded Systems",
        school: "Rwanda Coding Academy",
        period: "09/2023 – 07/2026",
        location: "Nyabihu",
    },
];

// `level` is the 1–5 rating shown on the CV.
export const skills = [
    { group: "Programming Languages", level: 4, items: ["JavaScript", "TypeScript", "Python", "Java", "SQL"] },
    {
        group: "Frontend Development",
        level: 3,
        items: ["React", "React Native", "Next.js", "HTML5", "CSS3", "Tailwind CSS", "Responsive Design"],
    },
    {
        group: "Backend Development",
        level: 5,
        items: ["Node.js", "Express.js", "RESTful APIs", "Authentication", "API Integration", "Prisma", "Server-Side Development"],
    },
    {
        group: "Databases & Data",
        level: 4,
        items: ["PostgreSQL", "MySQL", "MongoDB", "Database Design", "SQL", "Data Modeling"],
    },
    {
        group: "DevOps & Cloud",
        level: 5,
        items: [
            "Docker",
            "Docker Compose",
            "Kubernetes",
            "Linux",
            "CI/CD",
            "GitHub Actions",
            "Nginx",
            "AWS",
            "Cloudflare",
            "Vercel",
            "Environment Configuration",
        ],
    },
    {
        group: "Version Control & Development Tools",
        level: 5,
        items: ["Git", "GitHub", "Postman", "VS Code", "API Testing", "Debugging"],
    },
    {
        group: "AI-Assisted Development",
        level: 4,
        items: ["Claude Code", "Cursor", "Windsurf", "LLMs", "AI APIs", "Prompt Engineering", "OCR"],
    },
    { group: "Other Technologies", level: 5, items: ["BIM Technologies", "Revit API", "Archicad", "PDF/Word Generation"] },
];

export const languages = [
    { name: "English", level: 4 },
    { name: "Kinyarwanda", level: 5 },
];

// Contact details for references are kept off the public site; they are in the downloadable CV.
export const references = [
    { name: "Louis Mukama", role: "AI/ML Instructor", organization: "Rwanda Coding Academy" },
    { name: "Samuel Niyokwizerwa", role: "Senior QS and Owner", organization: "Digital Cost estimation" },
];

export const hobbies = ["Coffee-fueled coding sessions", "Swimming", "Exploring cryptocurrency and blockchain"];
